<div class="card-container">
  <div class="title-wrapper">
    <h3>Room Size</h3>
  </div>
  <div class="sizes-div">
    @for (item of roomSizesExamples; track item.title) {
      <div
        class="map-size-example"
        (click)="setRoomMaxCapacity(item.numberParticipants.toString(), item.size.toString(), item.title)"
        [ngClass]="{ selected: selectedSize === item.size.toString() }"
      >
        <div class="map-size-title">
          {{ item.title }}
        </div>
        <div class="map-size-image">
          <img alt="Size example" [src]="getImagePath(item.image)" [ngClass]="item.image" />
        </div>
        <div class="map-size-description">
          <div>{{ item.numberParticipants }} participants</div>
          <div>{{ item.size }}x{{ item.size }} px</div>
        </div>
      </div>
    }
  </div>
  <div class="input-div">
    <h3>Set room capacity</h3>

    <mat-slider
      class="slider"
      aria-labelledby="group-size-slider"
      [max]="maxRoomCapacity"
      [min]="2"
      [discrete]="true"
      #ngSlider
    >
      <input placeholder="slider" matSliderThumb [(ngModel)]="roomCapacity" #ngSliderThumb="matSliderThumb" />
    </mat-slider>

    <div class="capacity-desc">Max capacity {{ roomCapacity }}</div>
  </div>
  <div class="footer-wrapper">
    @if (hasBackStepButton) {
      <button data-testid="secondaryButton" class="secondary-button" (click)="backStep()">Back</button>
    }
    <button data-testid="primaryButton" class="primary-button" (click)="nextStep()">
      {{ isCreateFlow ? 'Next' : 'Apply' }}
    </button>
  </div>
</div>
